import { useEffect, useState } from 'react';

type TUseStepperArgs<Slide> = {
  slides: Slide[];
  timeout?: number;
};

export const useStepper = <T,>({ slides, timeout = 7000 }: TUseStepperArgs<T>) => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const currentSlide = slides[currentSlideIndex];
  const slidesLength = slides.length;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlideIndex((prevQuoteIndex) => (prevQuoteIndex + 1) % slidesLength);
    }, timeout);

    return () => clearInterval(interval);
  }, [slidesLength, timeout]);

  return {
    currentSlide,
    currentSlideIndex,
    slides,
    slidesLength,
    setCurrentSlideIndex,
  };
};
